import { client } from '@/common-utils/libraries/axios/axios';
import { POS_TERMINALS } from '../../../terminals/api/apiUrls';
import { replaceParameters } from '@/common-utils/functions/restUtils';
import posTerminalFields from '../../../terminals/fields/posTerminalFields';

/**
 * Map the response data to the pos terminal fields
 * @param {Array} items Response data
 * @returns {Object} Mapped data
 */
function mapResponseData(items) {

    const mappedItems = items.redisKeysFetched.map(item => ({
        [posTerminalFields.REDIS_KEYS_FETCHED.REDIS_KEY.key]: item[posTerminalFields.REDIS_KEYS_FETCHED.REDIS_KEY.key],
        [posTerminalFields.REDIS_KEYS_FETCHED.REDIS_VALUE.key]: item[posTerminalFields.REDIS_KEYS_FETCHED.REDIS_VALUE.key],
        [posTerminalFields.REDIS_KEYS_FETCHED.REDIS_STATUS.key]: item[posTerminalFields.REDIS_KEYS_FETCHED.REDIS_STATUS.key],
        [posTerminalFields.REDIS_KEYS_FETCHED.REDIS_START_DATE.key]: item[posTerminalFields.REDIS_KEYS_FETCHED.REDIS_START_DATE.key]
    }));

    const data = {
        [posTerminalFields.SERIAL_NUMBER.key]: items[posTerminalFields.SERIAL_NUMBER.key],
        [posTerminalFields.MANUFACTURER.key]: items[posTerminalFields.MANUFACTURER.key],
        [posTerminalFields.STATUS_IN_DATEBASE.key]: items[posTerminalFields.STATUS_IN_DATEBASE.key],
        [posTerminalFields.REDIS_BLACKLIST_FETCHING_TIME.key]: items[posTerminalFields.REDIS_BLACKLIST_FETCHING_TIME.key],
        [posTerminalFields.REDIS_KEYS_FETCHED.key]: [...mappedItems]

    };

    return data;
}

const queryGetPosTerminalStatusInfo = (subscriptionId) => {
    return {
        queryFn: async () => {
            const response = await client.get(replaceParameters(POS_TERMINALS.INFO_STATUS_POS_TERMINAL.url, { posTerminalUuid: subscriptionId }));
            return mapResponseData(response.data);
        }
    };
};


export default queryGetPosTerminalStatusInfo;